
<template>
  <div class="information_box">
    <div class="outside_box">
      <div class="form_box" v-if="!isLoading">
        <img src="../../assets/images/inforbanner2.jpg" alt="" class="formbanner">
        <div v-if="!isChange">
          <div class="formcontent" v-if="!isSuccess">
            <form action="">
              <div class="title">高山书院学员信息表</div>
              <div class="borderline"></div>
              <div class="form_list">
                <div class="part firstPart">
                  <b class="modelTitle">一. 以下基本信息，用于学生资料留存</b>
                  <div class="form_group">
                    <b class="must">姓名</b>
                    <input type="text" v-model="registerData.name" class="text" name="name" v-validate="'required'">
                    <p class="warnname" v-show="errors.has('name')">请填写此项</p>
                  </div>
                  <div class="form_group">
                    <b class="must">国籍</b>
                    <input type="text" v-model="registerData.nationality" class="text" name="nationality" v-validate="'required'">
                    <p class="warnname" v-show="errors.has('nationality')">请填写此项</p>
                  </div>
                  <div class="form_group">
                    <b class="must">身份证号<span style="display:block;color:#666;font-size:14px;font-weight:300;">（无身份证请填写：无）</span></b>
                    <input type="text" v-model="registerData.idcard" class="text" name="idcard" v-validate="'required'">
                    <p class="warnname" v-show="errors.has('idcard')">请填写此项</p>
                  </div>
                  <div class="form_group">
                    <b class="must">身份证有效期（年/月/日）<span style="display:block;color:#666;font-size:14px;font-weight:300;">（无身份证请填写：无）</span></b>
                    <input type="text" v-model="registerData.idcard_date" class="text" name="idcard_date" v-validate="'required'">
                    <p class="warnname" v-show="errors.has('idcard_date')">请填写此项</p>
                  </div>
                  <div class="form-group idimg">
                    <b>身份证正反面照片</b>
                    <div style="margin-right:20px;">
                      <img id="frontimgResult" :src="registerData.front_url ? registerData.front_url : '/static/tx.png'" alt="" style="width:80px;height:80px;">
                      <form id="openFile" style="margin-bottom:10px;">
                        <p style="width:80px;text-align:center;font-size:14px;font-weight:bold;margin:0;position:relative;">
                          <a href="javascript:;">上传正面</a>
                          <input @change="preview('front')" id="front" type="file"  name="file" multiple="multiple" accept="image/png, image/jpeg" style="position:absolute;top:0;opacity: 0;-ms-filter: 'alpha(opacity=0)';width:100%;">
                        </p>
                      </form>
                    </div>
                    <div>
                      <img id="backimgResult" :src="registerData.back_url ? registerData.back_url : '/static/tx.png'" alt="" style="width:80px;height:80px;">
                      <form id="openFile">
                        <p style="width:80px;text-align:center;font-size:14px;font-weight:bold;margin:0;position:relative;">
                          <a href="javascript:;">上传反面</a>
                          <input @change="preview('back')" id="back" type="file"  name="file" multiple="multiple" accept="image/png, image/jpeg" style="position:absolute;top:0;opacity: 0;-ms-filter: 'alpha(opacity=0)';width:100%;">
                        </p>
                      </form>
                    </div>
                  </div>
                  <div class="form_group">
                    <b class="must">护照号<span style="display:block;color:#666;font-size:14px;font-weight:300;">（无护照请填写：无）</span></b>
                    <input type="text" v-model="registerData.passport" class="text" name="passport" v-validate="'required'">
                    <p class="warnname" v-show="errors.has('passport')">请填写此项</p>
                  </div>
                  <div class="form_group">
                    <b class="must">护照有效期（年/月/日）<span style="display:block;color:#666;font-size:14px;font-weight:300;">（无护照请填写：无）</span></b>
                    <input type="text" v-model="registerData.passport_date" class="text" name="passport_date" v-validate="'required'">
                    <p class="warnname" v-show="errors.has('passport_date')">请填写此项</p>
                  </div>
                  <div class="form-group">
                    <b>护照照片</b>
                    <img id="hzimgResult" :src="registerData.hz_url ? registerData.hz_url : '/static/tx.png'" alt="" style="width:80px;height:80px;">
                    <form id="openFile">
                      <p style="width:80px;text-align:center;font-size:14px;font-weight:bold;margin:0;position:relative;">
                        <a href="javascript:;">请选择</a>
                        <input @change="preview('hz')" id="hz" type="file"  name="file" multiple="multiple" accept="image/png, image/jpeg" style="position:absolute;top:0;opacity: 0;-ms-filter: 'alpha(opacity=0)';">
                      </p>
                    </form>
                  </div>
                  <div class="form_group">
                    <b class="must">所属行业</b>
                    <select v-model="registerData.industry" v-validate="'required'" name="industry">
                      <option selected = 'registerData.industry === ""' value="" disabled style="display:none;">请选择</option>
                      <option selected = 'registerData.industry === "教育"' value="教育">教育</option>
                      <option selected = 'registerData.industry === "金融/投资"' value="金融/投资">金融 / 投资</option>
                      <option selected = 'registerData.industry === "区块链"' value="区块链">区块链</option>
                      <option selected = 'registerData.industry === "医疗/医药"' value="医疗/医药">医疗 / 医药</option>
                      <option selected = 'registerData.industry === "互联网/科技"' value="互联网/科技">互联网 / 科技</option>
                      <option selected = 'registerData.industry === "泛娱乐/传媒"' value="泛娱乐/传媒">泛娱乐 / 传媒</option>
                      <option selected = 'registerData.industry === "实业"' value="实业">实业</option>
                      <option selected = 'registerData.industry === "其他"' value="其他">其他</option>
                    </select>
                    <!-- <input type="text" v-if="registerData.industry == '4'" class="text" style="margin-top:10px;"> -->
                    <p class="warnname" v-show="errors.has('industry')">请填写此项</p>
                  </div>
                  <div class="form_group">
                    <b class="must">常驻城市</b>
                    <input type="text" v-model="registerData.country" class="text" name="country" v-validate="'required'">
                    <p class="warnname" v-show="errors.has('country')">请填写此项</p>
                  </div>
                  <div class="form_group">
                    <b class="must">饮食禁忌</b>
                    <input type="text" v-model="registerData.diet_taboo" class="text" name="diet_taboo" v-validate="'required'">
                    <p class="warnname" v-show="errors.has('diet_taboo')">请填写此项</p>
                  </div>
                  <div class="form_group">
                    <b class="must">运动爱好</b>
                    <input type="text" v-model="registerData.hobby" class="text" name="hobby" v-validate="'required'">
                    <p class="warnname" v-show="errors.has('hobby')">请填写此项</p>
                  </div>
                  <div class="form_group">
                    <b class="must">文艺特长</b>
                    <input type="text" v-model="registerData.specialty" class="text" name="specialty" v-validate="'required'">
                    <p class="warnname" v-show="errors.has('specialty')">请填写此项</p>
                  </div>
                  <div class="form_group">
                    <b class="must">紧急联系人电话</b>
                    <input type="text" v-model="registerData.emergency_contact " class="text" name="emergency_contact " v-validate="'required'">
                    <p class="warnname" v-show="errors.has('emergency_contact ')">请填写此项</p>
                  </div>
                </div>
                <div class="borderline"></div>
                <div class="part secondPart">
                  <b class="modelTitle">二. 以下信息便于选择校服尺码以及日后学习用品寄送</b>
                  <div class="form_group">
                    <b class="must">衣服尺码<span style="display:block;color:#666;font-size:14px;font-weight:300;">(*注：校服偏大)</span></b>
                    <select v-model="registerData.size" v-validate="'required'" name="size">
                      <option selected = 'registerData.size === ""' value="" disabled style="display:none;">请选择</option>
                      <option selected = 'registerData.size === "XS"' value="XS">XS：155/ 80A</option>
                      <option selected = 'registerData.size === "S"' value="S">S：160/84A</option>
                      <option selected = 'registerData.size === "M"' value="M">M：165/ 88A</option>
                      <option selected = 'registerData.size === "L"' value="L">L：170/92A</option>
                      <option selected = 'registerData.size === "XL"' value="XL">XL：175/ 96A</option>
                      <option selected = 'registerData.size === "XXL"' value="XXL">XXL: 180/100A</option>
                      <option selected = 'registerData.size === "XXXL"' value="XXXL">XXXL: 185/104A</option>
                    </select>
                    <p class="warnname" v-show="errors.has('size')">请填写此项</p>
                  </div>
                  <div class="form_group four_group">
                    <b class="must">收件地址</b>
                    <input type="text" v-model="registerData.address" class="text" name="address" v-validate="'required'">
                    <p class="warnname" v-show="errors.has('address')">请填写此项</p>
                  </div>
                  <div class="form_group four_group">
                    <b class="must">收件人</b>
                    <input type="text" v-model="registerData.addressee" class="text" name="addressee" v-validate="'required'">
                    <p class="warnname" v-show="errors.has('addressee')">请填写此项</p>
                  </div>
                  <div class="form_group four_group">
                    <b class="must">联系电话</b>
                    <input type="text" v-model="registerData.tel" class="text" name="tel" v-validate="'required'">
                    <p class="warnname" v-show="errors.has('tel')">请填写此项</p>
                  </div>
                </div>
                <div class="borderline"></div>
                <div class="part thirdPart">
                  <b class="modelTitle">三. 以下信息，用于每一级的「高山书院」公众号学员名单发布</b>
                  <div class="form_group">
                    <b>个人标签： 请提供30字以内最能体现个人成就/特点的个人标签</b>
                    <b class="must">中文：（必填）</b>
                    <textarea v-model="registerData.tag" class="text" name="tag" v-validate="'required'"></textarea>
                    <p class="warnname" v-show="errors.has('tag')">请填写此项</p>
                    <b>英文：（可选填）</b>
                    <textarea v-model="registerData.tag_en" class="text" name="tag_en"></textarea>
                  </div>
                  <div class="form_group">
                    <b>公司简介/ Company Introduction: （请提供30字以内最能体现公司成果的简单介绍）</b>
                    <b class="must">中文：（必填）</b>
                    <textarea v-model="registerData.company_introduction" class="text" name="company_introduction" v-validate="'required'"></textarea>
                    <p class="warnname" v-show="errors.has('company_introduction')">请填写此项</p>
                    <b>英文：（可选填）</b>
                    <textarea v-model="registerData.company_introduction_en" class="text" name="company_introduction_en"></textarea>
                  </div>
                </div>
                <div class="borderline"></div> 
                <div class="part forthPart">
                  <b class="must modelTitle">四. 请上传一张个人形象照<span style="display:block;color:#666;font-size:14px;font-weight:300;">要求：商务或半商务；背景简单
                    <br>像素: 高清大图，10M以内。</span></b>
                  <div class="form-group">
                    <img id="file1imgResult" :src="registerData.img_url ? registerData.img_url : '/static/tx.png'" alt="" style="width:80px;height:80px;">
                    <form id="openFile">
                      <p style="width:80px;text-align:center;font-size:14px;font-weight:bold;margin:0;position:relative;">
                        <a href="javascript:;">请选择</a>
                        <input @change="preview('file1')" id="file1" type="file"  name="file" multiple="multiple" accept="image/png, image/jpeg" style="position:absolute;top:0;opacity: 0;-ms-filter: 'alpha(opacity=0)';">
                      </p>
                    </form>
                    <p id="warnImg" class="warnname">请上传照片</p>
                  </div>
                </div>
                <div class="borderline"></div>
              </div>
            </form>
            <div class="hasUnFinishUpload" v-show="imgUploadNum !== 0">
              <div>图片上传中......</div>
            </div>
            <div class="submit" >
              <input type="submit" value="提交" @click="registe">
            </div>
          </div>
          <div class="submitSuccess" v-else>
            <div><p>尊敬的{{registerData.name}}先生/女士：</p>您已成功提交高山书院学员信息表！</div>
          </div>
        </div>
        <div class="submitSuccess" v-else>
          <div><p>尊敬的{{registerData.name}}先生/女士：</p>您已提交过高山书院学员信息表！</div>
        </div>
      </div>
      <div v-else class="form_box loading_box">
        <img style="width:300px;margin:0 auto;display:block;" src="@/assets/images/load2.gif" alt="">
        <p style="text-align:center;">提交中，请耐心等候......</p>
      </div>
    </div>
  </div>
</template>
<style lang="less" scoped>
@import "informationform.less";
</style>
<script>
import axios from 'axios'
import wx from 'weixin-js-sdk'
export default {
  data () {
    return {
      isLoading: false,
      isSuccess: false,
      registerData: {
        name: '',
        nationality: '',
        idcard: '',
        idcard_date: '',
        passport: '',
        passport_date: '',
        industry: '',
        country: '',
        diet_taboo: '',
        hobby: '',
        specialty: '',
        emergency_contact: '',
        size: '',
        address: '',
        addressee: '',
        tel: '',
        tag: '',
        tag_en: '',
        company_introduction: '',
        company_introduction_en: '',
        img_url: '',
        front_url: '',
        back_url: '',
        hz_url: ''
      },
      hasImg: false,
      ids: '',
      isChange: false,
      isRightId: false,
      imgUploadNum: 0
    }
  },
  created () {
    this.getId()
    this.getShareInfo()
  },
  methods: {
    getId: function () {
      let self = this
      var name, value, id
      var str = location.href
      var num = str.indexOf('?')
      str = str.substr(num + 1)
      var arr = str.split('&')
      for (let i = 0; i < arr.length; i++) {
        num = arr[i].indexOf('=')
        if (num > 0) {
          name = arr[i].substring(0, num)
          value = arr[i].substr(num + 1)
          this[name] = value
          if (name === 'id') {
            // self.getIds(value)
            self.ids = value
            self.getInfor(self.ids)
            return
          }
        }
      }
    },
    getInfor: function (ids) {
      let self = this
      // console.log('ids' + ids)
      self.$http.get('https://pyapi.gasauniversity.com/v3/student/get_info/' + ids)
        .then(function (res) {
          console.log(res)
          let infor = res.data
          self.registerData.name = infor.name
          self.registerData.grade = infor.grade
          self.registerData.nationality = infor.nationality
          self.registerData.idcard = infor.ic_number
          if (infor.ic_number === '无') {
            self.registerData.idcard_date = '无'
          } else {
            self.registerData.idcard_date = infor.ic_experiation_date
          }
          self.registerData.passport = infor.passport_number
          if (infor.passport_number === '无') {
            self.registerData.passport_date = '无'
          } else {
            self.registerData.passport_date = infor.experiation_date
          }
          self.registerData.industry = infor.industry
          self.registerData.country = infor.city
          self.registerData.diet_taboo = infor.diet
          self.registerData.hobby = infor.hobby
          self.registerData.specialty = infor.speciality
          self.registerData.emergency_contact = infor.emergency_contact
          self.registerData.size = infor.shirt_size
          self.registerData.address = infor.ship_address
          self.registerData.addressee = infor.ship_name
          self.registerData.tel = infor.ship_tel
          self.registerData.tag = infor.profile
          self.registerData.tag_en = infor.profile_en
          self.registerData.company_introduction = infor.company_profile
          self.registerData.company_introduction_en = infor.company_profile_en
          self.registerData.img_url = infor.upload_avatar_url
          if (infor.completed) {
            self.isChange = true
          }
          self.isRightId = true
        })
        .catch(function (err) {
          console.log(err)
          self.$toast.error('加载用户信息失败！请检查网址是否正确？', {type: 'error', position: 'top', duration: 5000, queue: true})
        })
        .finally(function () {
          console.log(self.registerData)
          let shareDesc = ''
          if (self.registerData && self.registerData.name !== '') {
            shareDesc = self.registerData.name + ' ' + self.registerData.grade
          }
          console.log(shareDesc)
          self.getShareInfo(shareDesc)
        })
    },
    preview: function (id) {
      let self = this
      var file = document.getElementById(id).files[0]
      if (!file) {
        return
      }
      if (file && file.size > 1024 * 1024 * 10) {
        self.$toast.error('图片大小不能超过 10MB!', {type: 'error', position: 'top', duration: 5000, queue: true})
        return
      }
      self.imgUploadNum++
      var reader = new FileReader()
      var imgFile
      reader.onload = function (e) {
        imgFile = e.target.result
        document.getElementById(id + 'imgResult').src = imgFile
      }
      reader.readAsDataURL(file)
      let param = new FormData()
      param.append('file', file)
      param.append('student_id', self.ids)
      axios.post('https://pyapi.gasauniversity.com/v3/student/upload_avatar', param, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(response => {
        self.imgUploadNum--
        console.log(4)
        let t = new Date().getTime()
        if (id === 'file1') {
          self.registerData.img_url = response.data.url + '?t=' + t
        } else {
          self.registerData[id + '_url'] = response.data.url + '?t=' + t
          // console.log(self.registerData[id + '_url'])
        }
      }).catch(err => {
        self.imgUploadNum--
        console.log(err)
        self.$toast.error('上传失败', {type: 'error', position: 'top', duration: 5000, queue: true})
      })
      if (id === 'file1') {
        document.getElementById('warnImg').style.display = 'none'
      }
    },
    registe: function () {
      let self = this
      if (!self.isRightId) {
        self.$toast.error('加载用户信息失败！请检查网址是否正确？', {type: 'error', position: 'top', duration: 5000, queue: true})
        return
      }
      // console.log(self.registerData)
      self.$validator.validate().then(result => {
        if (result) {
          if (self.ids === 'kgapM44VEA') {
            self.postData()
            return
          }
          if (!self.registerData.img_url) {
            document.getElementById('warnImg').style.display = 'block'
            self.$toast.error('请上传您的形象照！', {type: 'error', position: 'top', duration: 5000, queue: true})
          } else {
            self.postData()
          }
        } else {
          self.$toast.error('请确保您的所有信息已经填写完整！', {type: 'error', position: 'top', duration: 5000, queue: true})
        }
      })
    },
    postData: function () {
      let self = this
      console.log(self.registerData)
      self.$http.post('https://pyapi.gasauniversity.com/v3/student/edit_info', {
        ids: self.ids,
        name: self.registerData.name,
        nationality: self.registerData.nationality,
        ic_number: self.registerData.idcard,
        ic_experiation_date: self.registerData.idcard_date,
        ic_image_a: self.registerData.front_url,
        ic_image_b: self.registerData.back_url,
        passport_number: self.registerData.passport,
        experiation_date: self.registerData.passport_date,
        passport_image: self.registerData.hz_url,
        industry: self.registerData.industry,
        city: self.registerData.country,
        diet: self.registerData.diet_taboo,
        hobby: self.registerData.hobby,
        speciality: self.registerData.specialty,
        emergency_contact: self.registerData.emergency_contact,
        shirt_size: self.registerData.size,
        ship_address: self.registerData.address,
        ship_name: self.registerData.addressee,
        ship_tel: self.registerData.tel,
        profile: self.registerData.tag,
        profile_en: self.registerData.tag_en,
        company_profile: self.registerData.company_introduction,
        company_profile_en: self.registerData.company_introduction_en,
        upload_avatar_url: self.registerData.img_url
      })
        .then(function (res) {
          self.isLoading = false
          self.isSuccess = true
          // console.log(res)
        })
        .catch(function (err) {
          self.$toast.error('提交失败 请重新提交！', {type: 'error', position: 'top', duration: 5000, queue: true})
          console.log(err)
          self.isLoading = false
        })
    },
    getShareInfo (desc) {
      let self = this
      let postData = JSON.stringify({url: window.location.href.split('#')[0]})
      let sharelink = location.href.split('#')[0]
      console.log(postData)
      self.$http.post('https://gasawxapi.gwcevents.com/get_sign_package', postData).then((res) => {
        console.log(res)
        wx.config({
          debug: false,
          appId: res.data.appId,
          timestamp: res.data.timestamp,
          nonceStr: res.data.nonceStr,
          signature: res.data.signature,
          jsApiList: [
            'onMenuShareAppMessage',
            'hideMenuItems'
            // 'onMenuShareTimeline'
          ]
        })
        wx.error(function (err) {
          console.log(err)
        })
        wx.ready(function () {
          // wx.onMenuShareTimeline({
          //   title: '高山书院学员信息表',
          //   link: sharelink,
          //   imgUrl: 'https://static.gasauniversity.com/GASA_Share/gasa-logo-1.png',
          //   success: function () {
          //   },
          //   cancel: function () {
          //   }
          // })
          wx.onMenuShareAppMessage({
            title: '高山书院学员信息表', // 分享标题
            desc: desc, // 分享描述
            link: sharelink,
            imgUrl: 'https://static.gasauniversity.com/GASA_Share/gasa-logo-1.png', // 分享图标
            success: function () {
            },
            cancel: function () {
            }
          })
          wx.hideMenuItems({
            menuList: ['menuItem:share:timeline',
              'menuItem:share:qq',
              'menuItem:share:weiboApp',
              'menuItem:favorite',
              'menuItem:share:facebook',
              'menuItem:share:QZone',
              'menuItem:copyUrl',
              'menuItem:originPage',
              'menuItem:openWithQQBrowser',
              'menuItem:openWithSafari',
              'menuItem:share:email'] // 要隐藏的菜单项，只能隐藏“传播类”和“保护类”按钮，所有menu项见附录3
          })
        })
      })
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/informationform/informationform.vue